import { Injectable } from '@angular/core';
import { HttpService } from '../../services/http/http.service';
import { Path } from '../../utils/constant/paths';
import * as Constant from 'src/app/utils/constant';
import { HelperService } from 'src/app/services';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { of as observableOf } from 'rxjs';
import { CommonHttpDataService } from 'src/app/services/http/common-http-data.service';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoginService extends CommonHttpDataService {

  constructor(
    private http: HttpService,
    private helper: HelperService
  ) {
    super();
   }

  requestUserData() {
    return this.http.post(Path.USER.GET_DETAIL, null, null);
  }

  updateLastChangePasswordDate(params) {
    // let headers = {
    //   [HTTP_HEADER_MODULE_CODE]: this.helper.convertToBase64("BocDashboardModule")
    // };
    // return this.http.post(Path.BOC_DASHBOARD.GET_TABLE_OVERSTAYING, data, headers);
    return observableOf(
      {
        "message":"Success",
        "responseData":[
            {
              "family_name": "Dela Cruz",
              "given_name": "Juan",
              "middle_name": null,
              "suffix": null,
              "contact_numbers": "09123456789, 09123456789",
              "email_address": "juandelacruz@email.com",
              "country": {
                  "name": "Afghanistan",
                  "isoCode": "AF",
                  "flag": "🇦🇫",
                  "phonecode": "93",
                  "currency": "AFN",
                  "latitude": "33.00000000",
                  "longitude": "65.00000000",
                  "timezones": [
                      {
                          "zoneName": "Asia/Kabul",
                          "gmtOffset": 16200,
                          "gmtOffsetName": "UTC+04:30",
                          "abbreviation": "AFT",
                          "tzName": "Afghanistan Time"
                      }
                  ]
              },
              "state": {
                  "name": "Badakhshan",
                  "isoCode": "BDS",
                  "countryCode": "AF",
                  "latitude": "36.73477250",
                  "longitude": "70.81199530"
              },
              "city": {
                  "name": "BANGUED (Capital)",
                  "prov_code": "1401",
                  "mun_code": "140101"
              },
              "address": "Test",
              "landmark": null,
              "zip_code": null,
              "province": {
                  "name": "ABRA",
                  "reg_code": "14",
                  "prov_code": "1401"
              },
              "barangay": {
                  "name": "Agtangao",
                  "mun_code": "140101"
              },
              "passport_number": "123",
              "place_issued": "Test",
              "date_issued": "2022-10-31T16:00:00.000Z",
              "expiry_date": "2022-11-29T16:00:00.000Z",
              "passport_images": null
           }
        ]
     }
    )
    // return this.http.post(Path.LOGIN.UPDATE_LAST_CHANGE_PASSWORD_DATE, params, {}, false);
  }

  requestUnAuthFAQData() {
    return this.http.getWithoutAuth(Path.PRIVACY_POLICY.GET_PRIVACY_POLICY).pipe(
      catchError(this.handleServiceErrors)
    )
  }

}
